import React, { useState } from "react";
import * as Icons from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// Shown after inviting a user: their emailed set-password link, with a copy fallback.
export function InviteLinkResult({ name, result }) {
  const [copied, setCopied] = useState(false);
  const link = result?.invite_link;
  const emailSent = result?.email_sent;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — select and copy the link manually");
    }
  };
  return (
    <div className="space-y-4" data-testid="invite-result">
      <div className="flex items-start gap-3 rounded-lg bg-[#3D8B65]/10 px-4 py-3.5">
        <Icons.CheckCircle2 size={20} className="mt-0.5 shrink-0 text-[#2E6B4E]" />
        <div className="text-sm text-[#2E6B4E]">
          <div className="font-semibold text-[#0B1729]">{name} has been added.</div>
          {emailSent
            ? <span>A secure link to set their password has been emailed to them.</span>
            : <span>Email delivery isn't configured yet — share the secure set-password link below with them directly.</span>}
        </div>
      </div>
      {link && (
        <div>
          <label className="mb-1 block text-xs font-medium text-[#1E2D44]/70">Set-password link (valid 48 hours)</label>
          <div className="flex items-center gap-2">
            <input
              readOnly
              value={link}
              data-testid="invite-link-input"
              className="h-10 flex-1 rounded-lg border border-[#E4E8EF] bg-[#F4F6F9] px-3 text-xs text-[#1E2D44]/80"
              onFocus={(e) => e.target.select()}
            />
            <Button type="button" variant="outline" onClick={copy} data-testid="copy-invite-link" className="h-10 shrink-0">
              {copied ? <Icons.Check size={15} /> : <Icons.Copy size={15} />}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
